/**
 * Status tokens shared across status-bearing primitives and widgets.
 * Centralising the colour mapping means every dot/pill/value renders consistently
 * across modules without copy-pasting Tailwind classes.
 *
 * `KpiStatus` (the semantic vocabulary) is owned by `@playbookai/types`
 * (`KPI_STATUSES`) and re-exported here; this file owns only the status →
 * Tailwind token mapping (a presentation concern that stays in the DS).
 */

import type { KpiStatus } from "@playbookai/types";

export type { KpiStatus };

export interface StatusToken {
  readonly dotClass: string;
  readonly textClass: string;
  readonly label: string;
}

/* Registry, not a switch (packages/ui CLAUDE.md §3): adding a status is one
   new key here. */
const STATUS_TOKENS: Record<KpiStatus, StatusToken> = {
  healthy: {
    dotClass: "bg-pb-green",
    textClass: "text-pb-green-text",
    label: "Healthy",
  },
  watch: {
    dotClass: "bg-pb-amber",
    textClass: "text-pb-amber-text",
    label: "Watch",
  },
  critical: {
    dotClass: "bg-pb-red",
    textClass: "text-pb-red-text",
    label: "Critical",
  },
  none: {
    dotClass: "bg-pb-border-strong",
    textClass: "text-pb-text-muted",
    label: "None",
  },
};

export function statusToken(status: KpiStatus): StatusToken {
  return STATUS_TOKENS[status];
}
